export default function ({ store, redirect }) {
  // Redirect to auth if current user is not set
  if (!store.state.user.currentUser && process.client) {
    return redirect('/auth')
  }
}
